import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Image,
  Alert,
} from "react-native";
import { FONT_FAMILY, THEME_COLORS } from "../themes";
import { SimpleLineIcons } from "@expo/vector-icons";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import AwesomeSlider from "react-awesome-slider";
import "react-awesome-slider/dist/styles.css";
import { Dropdown } from "./index";
import ZoomMedia from "@screen/v3/BudgetModule/components/ZoomMedia";
import { getMediaTypeFromURL } from "@src/utils/functions";
import VideoPlayer from "./VideoPlayer";

interface AlbumProps {
  images: { url: string; mediaType?: string; label?: string }[];
  thumbnailsToShow?: number;
  show?: boolean;
  hidePlaceholder?: boolean;
  toggleModal?: any;
  showNoCount?: boolean;
  width?: number;
  height?: number;
  placeHolderImg?: { url: string; mediaType?: string; label?: string };
}

const Carousel = ({
  showAlbum,
  setShowAlbum,
  toggleModal,
  images,
  openZoomImage,
  initialIndex,
}) => {
  const [currentIndex, setCurrentIndex] = useState(
    initialIndex ? initialIndex : 0
  );
  const [rotation, setRotation] = useState<number>(0);

  const currentIndexRef = useRef(initialIndex ? initialIndex : 0);
  const imagesRef = useRef(null);
  const closeHandlerRef = useRef<{
    setShowAlbum: (v: boolean) => void;
    toggleModal?: (v: boolean) => void;
  }>({ setShowAlbum });
  closeHandlerRef.current = { setShowAlbum, toggleModal };

  const isWidthWindowLarger =
    window?.innerWidth * 0.65 > window?.innerHeight * 0.87;

  useEffect(() => {
    imagesRef.current = images?.length;
  }, [images]);

  const goToNext = useCallback(() => {
    currentIndexRef.current = currentIndexRef.current + 1;
    if (currentIndexRef.current > imagesRef.current - 1)
      currentIndexRef.current = 0;

    setCurrentIndex(currentIndexRef.current);
  }, []);

  const goToPrev = useCallback(() => {
    currentIndexRef.current = currentIndexRef.current - 1;
    if (currentIndexRef.current < 0)
      currentIndexRef.current = imagesRef.current - 1;

    setCurrentIndex(currentIndexRef.current);
  }, []);

  useEffect(() => {
    const keyDownEvent = (event) => {
      if (event.key === "ArrowRight") {
        goToNext();
      } else if (event.key === "ArrowLeft") {
        goToPrev();
      }
    };
    document.addEventListener("keydown", keyDownEvent);
    return () => {
      document.removeEventListener("keydown", keyDownEvent);
    };
  }, [goToNext, goToPrev]);

  const renderButtonRight = (
    <TouchableOpacity onPress={goToNext}>
      <SimpleLineIcons name="arrow-right" size={40} color={"#FFFFFF"} />
    </TouchableOpacity>
  );

  const renderButtonLeft = (
    <TouchableOpacity onPress={goToPrev}>
      <SimpleLineIcons name="arrow-left" size={40} color={"#FFFFFF"} />
    </TouchableOpacity>
  );

  const onTransitionRequest = useCallback((val) => {
    currentIndexRef.current = val?.nextIndex;
    setCurrentIndex(currentIndexRef.current);
  }, []);

  const handleClose = useCallback(() => {
    closeHandlerRef.current.setShowAlbum(false);
    currentIndexRef.current = 0;
    setCurrentIndex(0);
    closeHandlerRef.current.toggleModal?.(false);
  }, []);

  return (
    <Dropdown
      show={showAlbum}
      onClose={handleClose}
      parentRef={null}
    >
      <View
        style={{
          minWidth: "65vw",
          height: "87vh",
          position: "relative",
          alignContent: "center",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <AwesomeSlider
          selected={currentIndex}
          onTransitionRequest={onTransitionRequest}
          infinite={images?.length > 1 ? true : false}
          buttonContentRight={renderButtonRight}
          buttonContentLeft={renderButtonLeft}
          organicArrows={false}
        >
          {images?.map((obj, index) => {
            return (
              <View
                key={index}
                style={{
                  alignContent: "center",
                  flexDirection: "row",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                {obj.mediaType === "VIDEO" ||
                getMediaTypeFromURL?.(obj?.url) === "VIDEO" ? (
                  <View
                    style={{
                      width: isWidthWindowLarger ? "87vh" : "65vw",
                      height: isWidthWindowLarger ? "80vh" : "62vw",
                    }}
                  >
                    <VideoPlayer url={obj?.url} />
                  </View>
                ) : (
                  // <video
                  //   style={{
                  //     width: isWidthWindowLarger ? "87vh" : '65vw',
                  //     height: isWidthWindowLarger ? "80vh" : '62vw',
                  //     // position: "absolute",
                  //     // top: 0,
                  //     // left: 0,
                  //     objectFit: 'contain',
                  //   }}
                  //   controls
                  //   src={obj.url}
                  // />
                  <img
                    src={obj.url}
                    style={{
                      width: isWidthWindowLarger ? "87vh" : "65vw",
                      height: isWidthWindowLarger ? "87vh" : "65vw",
                      maxHeight: "-webkit-fill-available",
                      objectFit: "contain",
                      rotate: `${rotation}deg`,
                    }}
                  />
                )}
                <View style={styles.iconCon}>
                  {obj?.label ? (
                    <Text
                      style={{
                        backgroundColor: THEME_COLORS.bgWhite,
                        paddingHorizontal: 5,
                        paddingVertical: 2,
                      }}
                    >
                      {obj.label}
                    </Text>
                  ) : null}
                  {getMediaTypeFromURL?.(obj?.url) !== "VIDEO" ? (
                    <TouchableOpacity
                      style={styles.zoomBtn}
                      onPress={() => setRotation((rotation % 360) + 90)}
                    >
                      <MaterialCommunityIcons
                        name="rotate-right"
                        size={25}
                        color={THEME_COLORS.white}
                      />
                    </TouchableOpacity>
                  ) : null}
                  {obj.mediaType !== "VIDEO" &&
                  getMediaTypeFromURL?.(obj?.url) !== "VIDEO" ? (
                    <TouchableOpacity
                      style={styles.zoomBtn}
                      onPress={() => openZoomImage("open", obj.url)}
                    >
                      <MaterialCommunityIcons
                        name="fullscreen"
                        size={25}
                        color={THEME_COLORS.white}
                      />
                    </TouchableOpacity>
                  ) : null}
                </View>
              </View>
            );
          })}
        </AwesomeSlider>
      </View>
    </Dropdown>
  );
};

export const ImageAlbumButton = ({
  images,
  thumbnailsToShow = 1,
  show,
  hidePlaceholder,
  showNoCount = false,
  toggleModal,
  width = 40,
  height = 40,
  placeHolderImg,
}: AlbumProps) => {
  const imageArrLength = images?.length;
  const isImageExists = imageArrLength > 0;
  const isImageExistsMoreThanOne = placeHolderImg
    ? placeHolderImg
    : imageArrLength - thumbnailsToShow >= 1;

  const [showAlbum, setShowAlbum] = useState(show ? show : false);
  const [viewZoom, setViewZoom] = useState(false);
  const [initialIndex, setInitialIndex] = useState(0);
  const zoomUri = useRef(null);

  useEffect(() => {
    setShowAlbum((prev) => (prev === show ? prev : show));
  }, [show]);

  const openZoomImage = useCallback((action: string, url: string) => {
    if (action === "open") setViewZoom(true);
    else setViewZoom(false);
    zoomUri.current = url;
  }, []);

  const imageClick = useCallback(
    (index: number) => {
      if (isImageExists) {
        setShowAlbum(true);
        setInitialIndex(index);
      } else Alert.alert("No Images to Show");
    },
    [isImageExists]
  );

  return (
    <>
      {hidePlaceholder ? null : (
        <>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            {[...new Array(thumbnailsToShow)?.fill(0)]?.map((i, index) => {
              return (
                <>
                  {
                    <TouchableOpacity
                      style={[
                        styles.img,
                        {
                          backgroundColor: "#D9D9D9",
                          width: width,
                          height: height,
                        },
                      ]}
                      disabled={!images?.[index]?.url}
                      onPress={() => imageClick(index)}
                    >
                      {images?.[index]?.url && (
                        <img
                          key={index}
                          src={
                            images?.[index]?.mediaType === "VIDEO" ||
                            getMediaTypeFromURL?.(images?.[index]?.url) ===
                              "VIDEO"
                              ? require("../../assets/play-button.png")
                              : images?.[index]?.url
                          }
                          style={{
                            width: width,
                            height: height,
                            borderRadius: 5,
                            borderWidth: 1.5,
                            borderColor: "grey",
                            objectFit: "contain",
                          }}
                        />
                      )}
                    </TouchableOpacity>
                  }
                  &nbsp;
                </>
              );
            })}

            {isImageExistsMoreThanOne && !showNoCount ? (
              <Text
                onPress={() => imageClick(thumbnailsToShow)}
                style={styles.text}
              >{`+${imageArrLength - thumbnailsToShow}`}</Text>
            ) : null}
          </View>
        </>
      )}
      {showAlbum ? (
        <Carousel
          openZoomImage={openZoomImage}
          showAlbum={showAlbum}
          setShowAlbum={setShowAlbum}
          toggleModal={toggleModal}
          images={images}
          initialIndex={initialIndex}
        />
      ) : null}
      {viewZoom ? (
        <ZoomMedia
          open={viewZoom}
          setOpen={(arg) => setViewZoom(arg)}
          imageUri={zoomUri.current}
        />
      ) : null}
    </>
  );

  return null;
};

const BeforeAfterImages = ({ beforeImages, afterImages }) => {
  return (
    <View style={{ marginTop: 2 }}>
      {beforeImages.length || afterImages.length ? (
        <View style={styles.photosView}>
          {beforeImages?.length ? (
            <View style={styles.beforeVw}>
              <Text style={styles.abs}>Before</Text>
              <ImageAlbumButton images={beforeImages} />
            </View>
          ) : (
            <View style={{ marginLeft: -10 }} />
          )}
          {afterImages?.length ? (
            <View style={styles.afterVw}>
              <Text style={styles.abs}>After</Text>
              <ImageAlbumButton images={afterImages} />
            </View>
          ) : (
            <></>
          )}
        </View>
      ) : (
        <></>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  photosView: {
    flexDirection: "row",
    marginVertical: 15,
  },
  beforeVw: {
    flexDirection: "row",
    alignItems: "center",
    marginRight: 10,
  },
  abs: {
    position: "absolute",
    bottom: -22,
    left: 1,
    fontFamily: FONT_FAMILY.two,
    color: "grey",
    fontSize: 12,
  },
  afterVw: {
    flexDirection: "row",
    alignItems: "center",
    marginLeft: 10,
  },
  zoomBtn: {
    width: 40,
    height: 40,
    borderRadius: 40,
    marginLeft: 20,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#3030304D",
  },
  iconCon: {
    position: "absolute",
    bottom: 20,
    right: 40,
    flexDirection: "row",
    alignItems: "center",
  },
  img: {
    borderRadius: 5,
  },
  text: {
    marginLeft: 6,
    fontFamily: FONT_FAMILY.two,
    color: THEME_COLORS.purple,
  },
});

export default memo(BeforeAfterImages);
